import { errorToast } from 'app/packs/src/utils/error-toast'
import { successToast } from 'app/packs/src/utils/success-toast'
import { EditorContext } from 'components/atoms/editor'
import { store } from 'store/index'
import { AsyncTaskOutput } from 'store/modules/async-tasks'
import { Position } from 'store/modules/positions'

export const onUseGeneratedPositionDescription = async (
  output: AsyncTaskOutput,
  position: Position,
  editor: React.RefObject<EditorContext>,
) => {
  const content = output.positionDescription?.output?.extracted?.trim() || ''

  if (!content) {
    errorToast('Sorry, the generated description was empty. Please try again.')
    return
  }

  const updated = await store.positions.update(position.id, {
    description: content,
  })

  if (!updated.success) {
    errorToast(
      'Sorry, there was a problem applying the AI description, please try again.',
    )
    return
  }

  successToast('Applied AI position description ✨')

  const DOC = {
    type: 'doc',
    content: [
      {
        type: 'paragraph',
        content: [{ type: 'text', text: content }],
      },
    ],
  }
  editor.current?.reset(DOC)
}
